import { writable } from "svelte/store"

let DocumentTemplate

export class DocObj {
  constructor() {
    this.template = {
      name: "",
      email: undefined,
      file: undefined,
      metadata: {
        receiver: {
          name: "",
        },
        document: {
          type: "",
        },
        issuer: {
          signatory: "",
        },
      },
      fileName: undefined,
      emailName: undefined,
    }
    this.active = 0
    this.resumeTemp = 0
    this.showCarousel = false
    this.activeTemplate = "Create New File Design Template"
    this.emailTemplate = "Create New Email Template"
    this.disabled = false
    this.emailDisabled = false
    this.fileDisabled = false
    this.tempDocId = undefined
  }
}

/**
 * @type {DocumentCarousel}
 */
let Document = localStorage.getItem("P2BDocument")

if (typeof Document != "Object") {
  try {
    Document = JSON.parse(Document)
    if (!Document) {
      Document = new DocObj()
      // throw new Error("Document value is null")
    }
  } catch (error) {
    // console.error(error)
  }
}

/**
 * @typedef {Object} Item - contain id and name of the template
 * @type {Object}
 * @property {String} id - MongoDB id of the template
 * @property {String} name - name of the template
 * @property {String} created - when the template created
 * @property {String} src - file image url to be shown in file template selection carousel
 *
 */

/**
 * Metadata for a document.
 * @typedef {Object} metadata
 * @property {ReceiverInfo} receiver - Information about the document receiver.
 * @property {DocumentInfo} document - Information about the document.
 * @property {IssuerInfo} issuer - Information about the document issuer.
 */

/**
 * Information about the document receiver.
 * @typedef {Object} ReceiverInfo
 * @property {string} name - The name of the document receiver.
 */

/**
 * Information about the document.
 * @typedef {Object} DocumentInfo
 * @property {string} type - The type of the document.
 */

/**
 * Information about the document issuer.
 * @typedef {Object} IssuerInfo
 * @property {string} signatory - The name of the signatory who issued the document.
 */

/**
 * @typedef {Object} DocumentTemplate - represents the document template
 * @type {Object}
 * represents the document template
 *
 * @property {string} name - name of the document template
 * @property {Array<Item>} email - list of email templates
 * @property {Array<Item>} file - list of file templates
 * @property {metadata} metadata - Metadata json.
 * @property {String} fileName - selected file template name
 * @property {String} emailName - selected email template name
 */

/**
 * @typedef {Object} DocumentCarousel - contain templates list
 * @type {Object}
 *
 * @property {DocumentTemplate} template - document template object
 * @property {Boolean} showCarousel - flip to show new document template create carousel
 * @property {Number} active - denotes the active template index
 * @property {Number} resumeTemp - active value which is stored for resuming slides
 * @property {String} activeTemplate - indicates active file template
 * @property {Boolean} disabled - to check button disabled or not
 * @property {Boolean} emailDisabled - to check button disabled or not in email page
 * @property {Boolean} fileDisabled - to check button disabled or not in file page
 * @property {String} emailTemplate - indicates active email template
 * @property {String} tempDocId - to store temporary documentId for email creation process

 */

/**
 * @type {import("svelte/store").Writable<DocumentCarousel>}
 */

const DocumentCarousel = writable(Document)
export const updateDocStores = (Document) => {
  localStorage.setItem("P2BDocument", JSON.stringify(Document))
}

export default DocumentCarousel
